import React, { useEffect, useState } from 'react';
import { Collapse, Empty, Spin, Tag } from 'antd';
import api from '@/utils/api';
import { isValidDate, getActionColor } from '@/utils/helpers';
import AuditLogDiffTable from './AuditLogDiffTable';

const { Panel } = Collapse;

const AuditTimeline = ({ subjectType, subjectId, includeRelated = false }) => {
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);

    useEffect(() => {
        if (!subjectType || !subjectId) return;
        setLoading(true);
        api.get(`/audit-logs/timeline/${encodeURIComponent(subjectType)}/${subjectId}`, {
            params: { include_related: includeRelated ? 1 : 0 },
        }).then(res => setItems(res.data.data || []))
            .catch(() => setItems([]))
            .finally(() => setLoading(false));
    }, [subjectType, subjectId, includeRelated]);

    if (loading) return <div style={{ textAlign: 'center', padding: 24 }}><Spin /></div>;
    if (!items.length) return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Chưa có lịch sử thay đổi" />;

    return (
        <Collapse accordion bordered={false}>
            {items.map(item => (
                <Panel
                    key={item.id}
                    header={(
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
                            <Tag color={getActionColor(item.action)}>{item.display_action}</Tag>
                            <strong>{item.display_subject}</strong>
                            <span style={{ color: '#595959' }}>{item.actor_name || item.user?.full_name || 'Hệ thống'} · {isValidDate(item.created_at, true)}</span>
                        </div>
                    )}
                >
                    <AuditLogDiffTable before={item.before} after={item.after} changes={item.display_changes || []} />
                </Panel>
            ))}
        </Collapse>
    );
};

export default AuditTimeline;

